import script from "./ClassVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassVideo.vue?vue&type=script&setup=true&lang=js"

import "./ClassVideo.vue?vue&type=style&index=0&id=66dbcaf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dbcaf0"]])

export default __exports__